import { Timestamp } from 'firebase/firestore';

export const convertTimestampToDate = (timestamp: { seconds: number }) => {
    return new Date(timestamp.seconds * 1000).toLocaleDateString('en-US');
};

export const toObject = (map = new Map()): object => {
    if (!(map instanceof Map)) return map;
    return Object.fromEntries(
        Array.from(map.entries(), ([k, v]) => {
            if (v instanceof Array) {
                return [k, v.map(toObject)];
            } else if (v instanceof Map) {
                return [k, toObject(v)];
            } else {
                return [k, v];
            }
        }),
    );
};

export const objectToArray = (obj: object): object[] => {
    return Object.entries(obj).map(([key, value]) => {
        return { id: key, ...value };
    });
};

export const convertDateToTimestamp = (date: Date) => {
    return Timestamp.fromDate(date);
};
